import styled from 'styled-components';

export const StyledSelectToken = styled.div`
  width: 100%;

  & select {
    height: 50px;
    width: 200px;
    border-radius: 30px;
  }

  & .select__control {
    height: 50px;
    width: 200px;
    border: none;
    border-radius: 30px;

    & .select__value-container {
      height: 100%;
    }

    // This is the down caret to select the dropdown
    & .select__indicators {
      /* background-color: red; */
    }
  }

  & .vault-select__control {
    height: 60px;
    width: 100%;
    border: 1px solid #e0e0e0;
    border-radius: 10px;

    & .vault-select__value-container {
      height: 100%;
    }
  }

  & .vault-select__indicator-separator {
    display: none;
  }

  & .select__indicator-separator {
    display: none;
  }

  & .select__menu {

    // This seems to be the outside border/container of the actual dropdown
    & .select__menu-list {
      /* background-color: purple; */
    }

    // This is each item in the actual dropdown 
    & .select__option {
    }
  }
`;

export const StyledMintOption = styled.div`
  display: flex;
  align-items: center;
  & img {
    margin-right: 5px;
    height: 30px;
    width: 30px;
  }
  & span {
    font-size: 16px;
    font-weight: 600;
    letter-spacing: 0.02px;
    line-height: 19px;
  }
`;
